module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Il tesoro del drago")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Di M.A. Church")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Essere amati da un drago significa essere trattati come un tesoro inestimabile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Cento anni fa, l’Alfa Montgomery, spinto dalla disperazione, ha scelto di correre un rischio: ha preso in prestito dei soldi dall’antico drago Warwick Ehecatl, lasciando come garanzia le terre del branco. Ora è arrivato il momento di pagare il debito, e i draghi non dimenticano… né perdonano. Warwick esige come risarcimento il figlio di Montgomery, Avery, e tre delle sue attività commerciali. Avery è un Omega e sa di essere praticamente inutile al branco, quindi potrebbe anche accettare, ma ha dei ripensamenti: il suo futuro compagno è terrificante, e sarebbe libero di fare di lui ciò che vuole.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Warwick è consapevole della reputazione della sua razza, ed è persino disposto ad ammettere che in parte sia meritata, ma preferirebbe tagliarsi la coda piuttosto che smorzare la luce negli occhi innocenti del compagno. Non sarà semplice, ma c’è qualcosa tra loro che ribolle sotto la superficie e che vale la pena di proteggere.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e636bf1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0003.vue
// module id = 63
// module chunks = 0